import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <App />
 );

reportWebVitals();